import { render, staticRenderFns } from "./statusBar.vue?vue&type=template&id=2e51fe42"
import script from "./statusBar.vue?vue&type=script&lang=js"
export * from "./statusBar.vue?vue&type=script&lang=js"
import style0 from "./statusBar.vue?vue&type=style&index=0&id=2e51fe42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports